import type { DictionaryType } from 'types/global.types';

export const stringKeys = [
  'string.base',
  'string.empty',
  'string.email',
  'string.min',
  'string.max',
  'string.pattern.base',
  'string.length',
];

export const numberKeys = [
  'missing.number',
  'number.type',
  'number.base',
  'number.min',
  'number.max',
  'number.empty',
  'number.integer',
];

const keys = [
  'any.only',
  'any.empty',
  'any.required',
  'any.invalid',
  ...stringKeys,
  ...numberKeys,
  'array.min',
  'array.max',
  'array.length',
  'object.required',
  'object.base',
  'date.min',
  'date.max',
  'date.less',
  'date.format',
  'date.base',
  'any.ref',
  'string.pattern.base',
  'date.invalid',
];

export const formatErrorMessage = (
  prefix: string,
  label: string,
): DictionaryType =>
  keys.reduce((acc, val) => {
    // Return the same key for .base and .empty — both mean "value is missing"
    const parsedKeyValue = val.replace('.base', '.empty');
    return { ...acc, [val]: `${prefix}.${label}.${parsedKeyValue}` };
  }, {});
